// src/pages/seo/components/FieldWithAI.tsx

import React from 'react';
import { AiControls } from './AiControls';
import { UndoChip } from './UndoChip';
import { InfoPopover } from './InfoPopover';

export function FieldWithAI({
  label, fieldKey, value, onChange, aiSuggest, context, onUndo, previous
}: {
  label: string;
  fieldKey: string;
  value: string;
  onChange: (v: string) => void;
  aiSuggest: (fieldKey: string, ctx: any) => Promise<string>;
  context: any;
  onUndo: () => void;
  previous?: string;
}) {
  const [open, setOpen] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  const [suggestion, setSuggestion] = React.useState<string>('');
  async function regen() {
    setLoading(true);
    try { const s = await aiSuggest(fieldKey, context); setSuggestion(s); }
    finally { setLoading(false); }
  }
  return (
    <div className="mb-6">
      <div className="flex items-center gap-2">
        <label className="font-medium">{label}</label>
        <button className="text-xs underline" onClick={()=>setOpen(v=>!v)}>Info</button>
        <UndoChip onUndo={()=>{ if (previous!==undefined) onChange(previous); onUndo(); }} />
      </div>
      {open && (
        <div className="border rounded bg-white shadow p-3 my-2">
          <InfoPopover fieldKey={fieldKey} />
        </div>
      )}
      <textarea className="w-full border rounded p-2" rows={3} value={value} onChange={e=>onChange(e.target.value)} />
      <div className="mt-2 text-xs text-gray-600">
        <div className="border rounded p-2 bg-gray-50">
          <div className="font-medium mb-1">AI suggestion (read-only)</div>
          <pre className="whitespace-pre-wrap text-[12px]">{suggestion || ' '}</pre>
          <AiControls loading={loading} onRegenerate={regen} onUse={()=>onChange(suggestion)} />
        </div>
      </div>
    </div>
  );
}